"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BaseInvite () {
        return _baseinvite.default;
    },
    get BaseRoleUpdate () {
        return _baseroleupdate.default;
    },
    get FormSubmission () {
        return _formsubmission.default;
    },
    get OrganizationInvite () {
        return _orginvite.default;
    },
    get OrganizationRoleUpdate () {
        return _orgroleupdate.default;
    },
    get PasswordReset () {
        return _passwordreset.default;
    },
    get VerifyEmail () {
        return _verifyyouremail.default;
    },
    get Welcome () {
        return _welcome.default;
    }
});
const _welcome = /*#__PURE__*/ _interop_require_default(require("~/services/mail/templates/welcome"));
const _baseinvite = /*#__PURE__*/ _interop_require_default(require("~/services/mail/templates/base-invite"));
const _passwordreset = /*#__PURE__*/ _interop_require_default(require("~/services/mail/templates/password-reset"));
const _verifyyouremail = /*#__PURE__*/ _interop_require_default(require("~/services/mail/templates/verify-your-email"));
const _orginvite = /*#__PURE__*/ _interop_require_default(require("~/services/mail/templates/org-invite"));
const _orgroleupdate = /*#__PURE__*/ _interop_require_default(require("~/services/mail/templates/org-role-update"));
const _baseroleupdate = /*#__PURE__*/ _interop_require_default(require("~/services/mail/templates/base-role-update"));
const _formsubmission = /*#__PURE__*/ _interop_require_default(require("~/services/mail/templates/form-submission"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
